import { CardNetwork } from "frontend-client";

export const getCardIcon = (network?: CardNetwork | string) => {
  if (typeof network === "string") return network;

  switch (network) {
    case CardNetwork.AMEX:
      return "amex";
    case CardNetwork.DISCOVER:
      return "discover";
    case CardNetwork.MASTERCARD:
      return "mastercard";
    case CardNetwork.VISA:
      return "visa";
    case CardNetwork.JCB:
      return "jcb";
    case CardNetwork.MAESTRO:
      return "maestro";
    case CardNetwork.CHINA_UNION_PAY:
      return "unionPay";
    case CardNetwork.DINERS:
      return "dinersClub";
    case CardNetwork.CARTES_BANCAIRES:
      return "cartesBancaires";
    default:
      return "";
  }
};
